<script>
	import Navigation from './components/Navigation.svelte';
	import Main from './components/Main.svelte';
	import Home from './components/Home.svelte';
	import Projects from './components/Projects.svelte';
	import UnderConstruction from './components/UnderConstruction.svelte';

	let component = Home;

	const homePage = () => {
		component = Home;
	}

	const projectsPage = () => {
		component = Projects;
	}

	function changeComponent(event) {
		let componentName = event.detail.text;
		switch (componentName) {
			case 'Home':
				homePage();
				break;
			case 'Projects':
				projectsPage();
				break;
			default:
				break;
		}

	}
</script>

<svelte:head>
    <link href="https://fonts.googleapis.com/css2?family=Barlow:wght@300;400&display=swap" rel="stylesheet"> 
</svelte:head>

<div class="grid md:grid-cols-5 h-screen">
	<Navigation on:message={changeComponent}/>
	<Main component={component}/>
</div>